import styled from 'styled-components';
import React from 'react';
import { select } from '~/lib/select';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaPlayerStore } from './MediaPlayerStore';
import { ReplayButton } from '~/ui/buttons/ReplayButton';

const Button = styled(ReplayButton)`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9000;

  @media ((max-width: 580px) and (max-height: 300px)) {
    bottom: 5px;
    left: 10px;
  }
`;

const selector = (s: MediaPlayerStore) =>
  select(s, 'currentTime', 'seek', 'status', 'restart', 'play', 'toggle');

export const ReplayMediaBtn = () => {
  const { currentTime, seek, status, restart, play, toggle } = useMediaPlayerStore(selector);

  if (!currentTime || status === 'nomedia' || status !== 'done') return null;

  return (
    <Button
      onClick={() => {
        restart();
        setTimeout(() => play(), 300);
      }}
    >
      <p aria-hidden={'true'}>R</p>
    </Button>
  );
};
